import { Button } from 'components/ui/button';
import React from 'react';

const DocComponents = () => {
  return (
    <div className='component:DocComponents tw-p-2 tw-bg-white tw-min-h-[100vh]'>
      <h3 className='tw-mb-2'>Button</h3>
      <div className='tw-flex tw-gap-2'>
        <Button>Button primary</Button>
        <Button variant='secondary'>Button secondary</Button>
        <Button variant='outline'>Button outline</Button>
        <Button variant='destructive'>Button destructive</Button>
        <Button variant='ghost'>Button ghost</Button>
        <Button variant='link'>Button link</Button>
      </div>
    </div>
  );
};

export default DocComponents;
